import * as React from "react";

import {Popup} from "semantic-ui-react";

// components
import Button from "./Button";

export interface IDeleteButtonProps {
    /** Text to display on the main button. */
    label: string;

    /** Text to display on the confirmation button. */
    confirmLabel?: string;

    /** Whether the control should be disabled or not. */
    disabled?: boolean;

    /** Whether to require confirmation from the user or not (default: false). */
    requireConfirmation?: boolean;

    /** Callback for when the user has confirmend deletion. */
    onClick?: () => any;

    /** Style */
    style?: React.CSSProperties;
}

const renderDeleteBtn = (props: IDeleteButtonProps) => (
    <Button
        style={props.style}
        disabled={props.disabled}
        icon={"delete"}
        label={props.label}
        labelPosition="after"
        onClick={!props.requireConfirmation ? props.onClick : undefined}
    />
);

export const DeleteButton = (props: IDeleteButtonProps) => (
    !props.requireConfirmation ? (
        renderDeleteBtn(props)
    ) : (
        <Popup
            on="click"
            trigger={renderDeleteBtn(props)}
            content={(
                <Button
                    disabled={props.disabled}
                    label={props.confirmLabel}
                    onClick={() => {
                        if (props.onClick) {
                            props.onClick();
                        }
                    }}
                />
            )}
        />
    )
);

export default DeleteButton;



// WEBPACK FOOTER //
// ./src/components/DeleteButton.tsx